import React, { useState } from "react";
import {
  FORGET_PASSWORD_URL,
  FORGET_PASSWORD_OTP_URL,
} from "../constants/ApiPaths";
import {
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  Alert,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { SIGNIN_ROUTE } from "../constants/RoutePaths";
import { Link } from "react-router-dom";
import Iconawesomeeye from "../images/Iconawesomeeye.svg";
import Iconionicmdeyeoff from "../images/Iconionicmdeyeoff.svg";
import { NUMBER_REGEX } from "../constants/ValidationRegex";

function UpdatePassword(props) {
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmpasswordShown, setconfirmPasswordShown] = useState(false);

  const togglePassword = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const confirmTogglePassword = () => {
    setconfirmPasswordShown(confirmpasswordShown ? false : true);
  };

  const {
    reloading,
    enqueueSnackbar,
    setReLoading,
    history,
    useFormik,
    Yup,
    API,
    authHeader,
    CustomAlertMessage,
    CustomButtonLoader,
    email,
    setLoading,
  } = props;
  // intial values
  const initialValues = {
    email: email,
    otpValue: "",
    password: "",
    confirmPassword: "",
  };
  // validation schema
  const validationSchema = Yup.object().shape({
    otpValue: Yup.string()
      .matches(NUMBER_REGEX, "OTP must be Number")
      .required("OTP is Required"),
    password: Yup.string()
      .min(6, "Minimum 6 charcters required")
      .required("Password is Required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is Required"),
  });

  //formik
  const { handleSubmit, handleChange, values, handleBlur, errors, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema,
      onSubmit: (values) => getUpdatePassword(values),
    });

  //for updating password
  const getUpdatePassword = async (values) => {
    const { email, otpValue, password } = values;
    setReLoading(true);
    const config = {
      method: "PUT",
      url: FORGET_PASSWORD_URL,
      headers: authHeader(),
      data: {
        email: email,
        otpValue: parseInt(otpValue),
        password: password,
        hyperlink: window.location.host,
      },
    };
    try {
      const response = await API(config);
      const { status, message } = response.data;
      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        history(SIGNIN_ROUTE);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setReLoading(false);
    }
  };

  //for getting otp
  const getOTP = async (email) => {
    setLoading(true);
    const config = {
      method: "POST",
      url: FORGET_PASSWORD_OTP_URL,
      data: { email: email },
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status, message } = response.data;
      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h4>Update Your Password</h4>
      <div>
        <Alert color="success">
          <h4 className="alert-heading">Success!</h4>
          <p>{email && `We sent OTP successfully to ${email}`}</p>
        </Alert>
      </div>
      <Form form="true" onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="OTP">OTP</Label>
          <Input
            type="text"
            onBlur={handleBlur}
            name="otpValue"
            value={values.otpValue}
            invalid={touched.otpValue && errors.otpValue ? true : false}
            onChange={handleChange}
            id="OTP"
            placeholder="Enter OTP"
          />
          <FormFeedback>
            {touched.otpValue && errors.otpValue ? errors.otpValue : ""}
          </FormFeedback>
        </FormGroup>

        <FormGroup>
          <Label for="password">New Password</Label>
          <InputGroup>
            <Input
              type={passwordShown ? "text" : "password"}
              onBlur={handleBlur}
              name="password"
              value={values.password}
              invalid={touched.password && errors.password ? true : false}
              onChange={handleChange}
              id="password"
              placeholder="Enter New Password"
            />

            <>
              <InputGroupText
                onClick={togglePassword}
                style={{ cursor: "pointer" }}
              >
                {passwordShown ? (
                  <img src={Iconawesomeeye} alt=""/>
                ) : (
                  <img src={Iconionicmdeyeoff} alt=""/>
                )}
              </InputGroupText>
            </>
            <FormFeedback>
              {touched.password && errors.password ? errors.password : ""}
            </FormFeedback>
          </InputGroup>
        </FormGroup>

        <FormGroup>
          <Label for="confirmPassword">Enter Confirm Password</Label>
          <InputGroup>
            <Input
              type={confirmpasswordShown ? "text" : "password"}
              onBlur={handleBlur}
              name="confirmPassword"
              value={values.confirmPassword}
              invalid={
                touched.confirmPassword && errors.confirmPassword ? true : false
              }
              onChange={handleChange}
              id="confirmPassword"
              placeholder="Enter Confirm Password"
            />
            <>
              <InputGroupText
                onClick={confirmTogglePassword}
                style={{ cursor: "pointer" }}
              >
                {confirmpasswordShown ? (
                  <img src={Iconawesomeeye} alt=""/>
                ) : (
                  <img src={Iconionicmdeyeoff} alt=""/>
                )}
              </InputGroupText>
            </>
            <FormFeedback>
              {touched.confirmPassword && errors.confirmPassword
                ? errors.confirmPassword
                : ""}
            </FormFeedback>
          </InputGroup>
        </FormGroup>
        {/* Button */}
        <Button color="primary" type="submit" block>
          {reloading && <CustomButtonLoader />}
          Update
        </Button>
        <Link onClick={() => getOTP(email)}>Didn't get OTP?</Link>
      </Form>
    </div>
  );
}

export default UpdatePassword;
